module.exports = __webpack_public_path__ + "static/media/3wise_owl.f5698e87.gif";